import { gql } from "@apollo/client";
import { documentFieldsFragment } from "../queries/fragments/documentFields";

export const CREATE_REFERRAL = gql`
  mutation CreateReferral($clientId: Int!, $referral: ReferralInput!) {
    createReferral(clientId: $clientId, referral: $referral) {
      id
      displayableId
      sentReferralNetworkId
    }
  }
`;

export const UPDATE_REFERRAL = gql`
  mutation UpdateReferral(
    $clientId: Int!
    $processInstanceId: String!
    $referral: ReferralInput!
  ) {
    updateReferral(
      clientId: $clientId
      processInstanceId: $processInstanceId
      referral: $referral
    ) {
      id
      displayableId
      sentReferralNetworkId
    }
  }
`;

export const CLONE_REFERRAL = gql`
  mutation CloneReferral($clientId: Int!, $cloneReferralId: String!) {
    cloneReferral(clientId: $clientId, cloneReferralId: $cloneReferralId) {
      id
      displayableId
      sentReferralNetworkId
      type
      status
    }
  }
`;

export const ADD_DOCS_TO_REFERRAL = gql`
  mutation AddDocumentsToReferral(
    $clientId: Int!
    $processInstanceId: String!
    $documentIds: [String]!
  ) {
    addDocumentsToReferral(
      clientId: $clientId
      processInstanceId: $processInstanceId
      documentIds: $documentIds
    ) {
      clientId
      filename
    }
  }
`;

export const REMOVE_DOC_FROM_REFERRAL = gql`
  mutation RemoveDocumentFromReferral(
    $clientId: Int!
    $processInstanceId: String!
    $documentId: String!
  ) {
    removeDocumentFromReferral(
      clientId: $clientId
      processInstanceId: $processInstanceId
      documentId: $documentId
    )
  }
`;

export const SEND_REFERRAL_EVENT_MESSAGE = gql`
  mutation SendReferralEventMessage(
    $clientId: Int!
    $processInstanceId: String!
    $message: ReferralEventMessageInput!
  ) {
    sendReferralEventMessage(
      clientId: $clientId
      processInstanceId: $processInstanceId
      message: $message
    ) {
      id
      displayableId
      status
      type
    }
  }
`;

export const RESEND_FAX_FROM_REFERRAL = gql`
  mutation ResendFaxFromReferral($clientId: Int!, $processInstanceId: String!) {
    resendFaxFromReferral(
      clientId: $clientId
      processInstanceId: $processInstanceId
    )
  }
`;

export const CREATE_REFERRAL_PDF_MUTATION = gql`
  mutation CreateReferralPdf(
    $clientId: Int!
    $processInstanceId: String!
    $additionalText: String!
    $signPdf: Boolean
    $timeZone: String
  ) {
    createReferralPdf(
      clientId: $clientId
      processInstanceId: $processInstanceId
      additionalText: $additionalText
      signPdf: $signPdf
      timeZone: $timeZone
    ) {
      ...DocumentFields
    }
  }
  ${documentFieldsFragment}
`;
